export default __webpack_public_path__ + "static/media/BeaujolaisAd400.3707f4c7.jpg";